// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetGoogleReserveResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type WidgetGoogleReserveApiResponse = {
	id: number;
	name: string | null;
	hasStructuredAddress: boolean;
	disabledAt: string | null;
	country: string | null;
	locality: string | null;
	postal_code: string | null;
	street_address: string | null;
	region: string | null;
	latitude: number | null;
	longitude: number | null;
	fullAddress: string;
};

export type WidgetGoogleReserve = {
	id: number;
	name: string | null;
	hasStructuredAddress: boolean;
	disabledAt: DateTime | null;
	country: string | null;
	locality: string | null;
	postal_code: string | null;
	street_address: string | null;
	region: string | null;
	latitude: number | null;
	longitude: number | null;
	fullAddress: string;
};

export function hydrateWidgetGoogleReserve(data: WidgetGoogleReserveApiResponse): WidgetGoogleReserve {
	return {
		...data,
		disabledAt: DateTimefromISO(data.disabledAt),
	};
}